import { Trans, useTranslation } from 'react-i18next';

import { ConfirmationModal } from '@/modules/common/components/modals/confirmation-modal';
import { PatchEntityResult } from '@/modules/common/types/patch-entity-result';
import { formatCompactDateRange } from '@/utils/date-formatters';

interface PatchEntityDetailsResultModalProps {
  resultToDisplay: PatchEntityResult | null;
  onClose: () => void;
}

export function PatchEntityDetailsResultModal({
  resultToDisplay,
  onClose,
}: PatchEntityDetailsResultModalProps) {
  const { t } = useTranslation('common');

  const ranges =
    resultToDisplay && resultToDisplay?.patchedArchivedRanges?.length > 0
      ? resultToDisplay.patchedArchivedRanges.map(range =>
          formatCompactDateRange(range.startDate, range.endDate)
        )
      : null;

  return (
    <ConfirmationModal
      open={ranges != null && ranges.length > 0}
      onOpen={() => {}}
      onClose={onClose}
      title={t('common:patchEntityDetailsResultModal.title')}
      confirmText={t('common:close')}
      confirmVariant="default"
      onConfirm={closeModal => closeModal()}
      hideCancelButton
    >
      <div className="space-y-3 text-sm text-muted-foreground">
        <p>
          <Trans
            i18nKey="common:patchEntityDetailsResultModal.description"
            components={{ bold: <strong className="text-foreground" /> }}
          />
        </p>
        {ranges && (
          <ul className="ml-4 list-inside list-disc space-y-1">
            {ranges.map((range, index) => (
              <li key={index}>{range}</li>
            ))}
          </ul>
        )}
      </div>
    </ConfirmationModal>
  );
}
